export default __webpack_public_path__ + "static/media/como_funciona_03.facb2a6c.png";